export class ElectricityConsumption {
  static VERY_LOW = 1;
  static LOW = 2;
  static AVERAGE = 3;
  static BIG = 4;
  static VERY_BIG = 5;
}
